import React from 'react';
import {
  TableContainer as MuiTableContainer,
  type TableContainerProps,
} from '@mui/material';

export type DataContainerProps = TableContainerProps;

export default function DataContainer({
  children,
  ...props
}: DataContainerProps) {
  return <MuiTableContainer {...props}>{children}</MuiTableContainer>;
}
